module.exports = __webpack_public_path__ + "static/Recruit04_03-7d82ce9a37645d6f5191643d724379a4.png";